// React Imports
import { ReactElement } from "react";

// Local Imports
import CollapseComponent from "../../../../components/collapse.component";

interface PreferenceProps {
  [key: string]: any;
}

const Preferences: React.FC<PreferenceProps> = ({
  accountKycDetails,
}: PreferenceProps): ReactElement => {
  return (
    <section className="flex flex-col w-full h-full">
      <div className="flex flex-col p-[10px]">
        <CollapseComponent
          header={
            <div className="flex gap-3 items-center">
              <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
              <h3 className=" text-xl font-semibold">Preferences</h3>
            </div>
          }
        >
          <div className="flex gap-5 flex-wrap mb-5">
            <div className="w-[32%] flex flex-col">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Preferred language
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.preferredLanguage
                  ?.description || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Preferred reporting currency
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.reportingCurrency || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Correspondence preference
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.correspondencePreference
                  ?.description || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Email
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.primaryEmail || "-"}
              </span>
            </div>
            {accountKycDetails?.accountInfo[0]?.fax && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Fax
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.fax || "-"}
                </span>
              </div>
            )}
            {accountKycDetails?.branch === "SA" && (
              <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
                <p className=" text-black-300 text-xs font-normal mb-[10px]">
                  Preferred investment assets
                </p>
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.preferredInvestmentAssets
                    ?.description || "-"}
                </span>
              </div>
            )}
          </div>
        </CollapseComponent>
      </div>
    </section>
  );
};

export default Preferences;
